<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        SKTMT
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Nomor Surat</label>
          <b-form-input 
            v-model="filter.nomor_surat"
            placeholder="Nomor Surat"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Nama Dosen</label>
          <b-form-input 
            v-model="filter.nama_dosen"
            placeholder="Nama Dosen"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Tanggal Awal</label>
          <b-form-datepicker v-model="filter.tanggal_awal"  locale="id" ></b-form-datepicker>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-1"
        >
          <label>Tanggal Akhir</label>
          <b-form-datepicker v-model="filter.tanggal_akhir"  locale="id" ></b-form-datepicker>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mt-3"
        >
          <b-button variant="primary" @click="buat()">Buat SKTMT</b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton,BFormDatepicker, BFormGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  getJenisSidang,
  getStatusJadwalSidang,
  generateSKTMT,
} from '@/connection-api/master'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
    BFormDatepicker,
    BFormGroup,
  },
  data() {
    return {
      filter: {},
      count: 0,
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Sidang --' },
        ],
      },
      statusJadwalOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Jadwal Sidang --' },
        ],
      },
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  beforeCreate() {
      // getJenisSidang()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.jenisSidangOption.options.push({
      //       label: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      // }
      // })
      // .catch(error => console.log(error));

      // getStatusJadwalSidang()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.statusJadwalOption.options.push({
      //       label: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      // }
      // })
      // .catch(error => console.log(error));
  },
  methods: {
    buat()
    {
      generateSKTMT()
      .then(response => {
      if (response.data.success == true) {
       
      }
      })
      .catch(error => console.log(error));
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
